import { Injectable } from "@angular/core";
import { CostCenter } from 'src/shared/models/cost-center.model';
import { AncillaryConfiguration } from 'src/shared/models/ancillary-configuration.model';
import { UntypedFormGroup } from '@angular/forms';
import { Client } from "src/shared/models/client.model";

@Injectable()
export class WorkflowPageUtil {
    private static getCostCenterType(costCenterType: string): CostCenterType {
        if (!costCenterType) {
            return CostCenterType.none;
        }
        
        let type = CostCenterType.none;

        switch(costCenterType.toLowerCase()) {
            case ('ancillary'):
                type = CostCenterType.ancillary;
                break;
            case ('inpatient'):
                type = CostCenterType.inpatient;
                break;
            default:
                type = CostCenterType.none;
                break;
        }

        return type;
    }

    static isValidCensusForm(censusForm: UntypedFormGroup, hasTransfers: boolean) {
        return censusForm
            && censusForm.value['admits'] >= 0
            && (!hasTransfers || censusForm.value['transfersIn'] >= 0)
            && (!hasTransfers || censusForm.value['transfersOut'] >= 0)
            && censusForm.value['discharges'] >= 0;
    }

    static hasAcuityConfiguration(costCenter: CostCenter): boolean {
        return this.hasValidAcuityConfiguration(costCenter.costCenterType, costCenter.ancillaryConfiguration) && 
            !costCenter.ancillaryConfiguration.hasRoomTypes;
    }

    static hasAcuityWithRoomsConfiguration(costCenter: CostCenter): boolean {
        return this.hasValidAcuityConfiguration(costCenter.costCenterType, costCenter.ancillaryConfiguration) && 
            costCenter.ancillaryConfiguration.hasRoomTypes;
    }

    static hasInpatientConfiguration(costCenter: CostCenter): boolean {
        return this.getCostCenterType(costCenter.costCenterType) === CostCenterType.inpatient && 
            !!costCenter.inpatientConfiguration;
    }

    private static hasValidAcuityConfiguration(costCenterType: string, ancillaryConfiguration: AncillaryConfiguration): boolean {
        return this.getCostCenterType(costCenterType) === CostCenterType.ancillary &&
            ancillaryConfiguration && 
            ancillaryConfiguration.typeOfWorkTemplate && 
            ancillaryConfiguration.typeOfWorkTemplate == 'acuity';
    }

    static hasUosConfiguration(costCenter: CostCenter): boolean {
        let configuration = costCenter.ancillaryConfiguration;

        return this.getCostCenterType(costCenter.costCenterType) == CostCenterType.ancillary &&  
            !!configuration &&
            configuration.typeOfWorkTemplate &&
            configuration.typeOfWorkTemplate == 'total';
    }

    static hasTotalUosImports(client: Client, costCenter: CostCenter): boolean {
        return client && costCenter && client.ancillaryPatientUOS && WorkflowPageUtil.hasUosConfiguration(costCenter)
    }
}

export enum CostCenterType {
    ancillary,
    inpatient,
    none
}